import { Suspense } from "solid-js";
import { ToastRegion, ToastList } from "@/components/shadcn/toast"
import SiteLoader from "./components/ui/SiteLoader";
import { AppProvider, AuthProvider } from "./context";
import './App.css'
import ConfirmerProvider from "./context/confirmer";

export default function App(props) {
  return (
    <AppProvider>
      <ConfirmerProvider>
        <AuthProvider>
          <Suspense fallback={<SiteLoader />}>
            {props.children}
            <ToastRegion>
              <ToastList />
            </ToastRegion>
          </Suspense>
        </AuthProvider>
      </ConfirmerProvider>
    </AppProvider>
  )
}
